import { type ConsoleUser, type PlatformUser, findUserOrganization } from '@/stores/auth'

const SUPPORT_PORTAL_FALLBACK_URL = 'https://support.bytebeam.io'

export const validateSupportPortalLink = (value: string): string | null => {
	const link = value.trim()
	if (!link) {
		return null
	}
	let url: URL
	try {
		url = new URL(link)
	} catch {
		return 'Enter a full URL, for example https://support.bytebeam.io/redeem?token=...'
	}
	return url.protocol === 'https:' ? null : 'The link must start with https://'
}

export function resolveSupportPortalLink(user: ConsoleUser | PlatformUser | null | undefined, orgId: string): string {
	const link = findUserOrganization(user, orgId)?.frontend_settings?.support_portal_link?.trim()
	// The backend does not validate this field, so a value written outside the settings form is checked again here.
	if (!link || validateSupportPortalLink(link)) {
		return SUPPORT_PORTAL_FALLBACK_URL
	}
	const name = user?.name?.trim()
	if (!name) {
		return link
	}
	const url = new URL(link)
	url.searchParams.set('name', name)
	return url.toString()
}
